/* prettier-ignore */

import { Component, computed } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { ToolsService } from 'src/app/services/tools.service';
import { UserService } from 'src/app/services/user.service';
import { RegisterComponent } from 'src/app/shared/register/register.component';

@Component({
  selector: 'header-user-menu',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})

export class HeaderUserMenuComponent {
    public isLoggedIn = computed(() => this.authService.isLoggedIn());
    
    constructor(
        public googleTranslateService: GoogleTranslateService,
        public translate: TranslateService,
        public authService: AuthService,
        public tools: ToolsService,
        private userService: UserService,
        private modalCtrl: ModalController
    ) {}

    async register(){
        this.modalCtrl.dismiss();
        const registerModal = await this.modalCtrl.create({
            component: RegisterComponent,
            cssClass: 'registerModal',
        });
        await registerModal.present();
    }

    login(){
        this.userService.login();
    }

    logout(){
        this.authService.logout();
        this.userService.resetAll();
    }
}